import React from 'react'
import Box from '../../../core/components/box/Box'
import Text from '../../../core/components/typography/text/Text'
import Heading from '../../../core/components/typography/heading/Heading'
import {PrimaryButton, BorderlessButtonLight} from '../../../core/components/unilink/index'
import {withRouter} from 'react-router'
import SubjectToCSSName from '../../../core/less/SubjectToCSSName'
import {subjectToImage} from '../../../core/less/SubjectToImage'
// import lightningSVG from '../../../core/img/lightning.svg'
// import trophySVG from '../../../core/img/trophy.svg'

class ScoreScreen extends React.PureComponent {
  constructor(props) {
    super(props)
  }
  render() {
    const {numProblems, numCorrectProblems, bestStreak, subjectColorId, slug, continuePractice, leavePractice, history} = this.props

    const headingText = numCorrectProblems >= numProblems/2 ? 'Excellent Job!' : 'Keep on Practicing!'
    return (
      <Box maxWidth='40rem' paddingTop={8} width='100%'>
        <Box
          shape='round'
          overflow='hidden'
          display='flex'
          direction='column'
          color='white'
          shadow>
          <Box
            display='flex'
            justifyContent='center'
            overflow='hidden'
            maxHeight='15.6rem'
            color={`${SubjectToCSSName[subjectColorId]}-nav`}>
            <img
              style={{
                height: '17.125rem',
                width: 'auto',
                position: 'relative',
                bottom: '-2.5rem'
              }}
              src={subjectToImage[subjectColorId]} />
          </Box>
          <Box
            display='flex'
            direction='column'
            alignItems='center'
            paddingX={6}
            smPaddingX={10}
            paddingY={10}>
            <Box marginBottom={3}>
              <Heading
                align='center'
                fontWeight='bold'
                color='body'
                size='xl'>{headingText}</Heading>
            </Box>
            <Box marginBottom={2}>
              <Text fontWeight='book' align='center'>You answered the questions</Text>
              <Text fontWeight='book' align='center'>with {Math.round(numCorrectProblems/numProblems * 100)}% accuracy.</Text>
            </Box>
            <Box display='flex' justifyContent='center' marginBottom={2} position='relative' width='100%'>
              <Box
                display='flex'
                direction='column'
                alignItems='center'
                smMarginRight={5}
                smPaddingX={4}
                smPaddingY={8}
                marginRight={2}
                paddingX={2}
                paddingY={4}
                width='33%'>
                <Heading color={`${SubjectToCSSName[subjectColorId]}-cta`} size='xxl' fontWeight='bold' accessibilityLevel={2}>{numProblems-numCorrectProblems}</Heading>
                <Box marginTop={2}>
                  <Text color='midGray' fontWeight='medium' smSize='md' size='xs'>INCORRECT</Text>
                </Box>
              </Box>
              <Box
                display='flex'
                direction='column'
                alignItems='center'
                smMarginRight={5}
                smPaddingX={4}
                smPaddingY={8}
                marginRight={2}
                paddingX={2}
                paddingY={4}
                width='33%'>
                <Heading color={`${SubjectToCSSName[subjectColorId]}-cta`} size='xxl' fontWeight='bold' accessibilityLevel={2}>{numCorrectProblems}</Heading>
                <Box marginTop={2}>
                  <Text color='midGray' fontWeight='medium' smSize='md' size='xs'>CORRECT</Text>
                </Box>
              </Box>
              <Box
                display='flex'
                direction='column'
                alignItems='center'
                smPaddingX={4}
                smPaddingY={8}
                paddingX={2}
                paddingY={4}
                width='33%'>
                <Heading color={`${SubjectToCSSName[subjectColorId]}-cta`} size='xxl' fontWeight='bold' accessibilityLevel={2}>{bestStreak}</Heading>
                <Box marginTop={2}>
                  <Text color='midGray' fontWeight='medium' smSize='md' size='xs' truncate>BEST STREAK</Text>
                </Box>
              </Box>
            </Box>
            <Box display='flex' direction='column' justifyContent='center'>
              <Box marginBottom={2}>
                <PrimaryButton
                  fullwidth
                  onClick={()=>{
                    leavePractice()
                    history.push(slug)
                  }}
                  subjectColorId={subjectColorId}>Exit Practice</PrimaryButton>
              </Box>
              <BorderlessButtonLight
                onClick={continuePractice}
                subjectColorId={subjectColorId}>Continue practicing</BorderlessButtonLight>
            </Box>
          </Box>
        </Box>
      </Box>
    )
  }
}
export default withRouter(ScoreScreen)



// WEBPACK FOOTER //
// ./src/domains/grandmaster/components/ScoreScreen.js